let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i5s5V")).then(() => parcelRequire('2AfkR'));